import { pipe, Result } from '@blade/std-lib'

import type { PlatformUpdate } from '@root/shared'

export type UpdateLevel = 'major' | 'minor' | 'patch' | 'same'
export interface UpdateVersion {
  readonly major: number
  readonly minor: number
  readonly patch: number
}

/**
 *
 * version: 22.333.4444-abc4
 * @param update
 * @returns
 */
export const fromUpdate = (
  update: PlatformUpdate,
): Result.Result<UpdateLevel, undefined> => {
  const { currentVersion, version } = update

  const [curMain, _curAppendix] = currentVersion.split('-')
  const [newMain, _newAppendix] = version.split('-')

  if (!curMain || !newMain) {
    return Result.fail(undefined)
  }

  return pipe(
    parseUpdateVersion(curMain),
    Result.flatMap((curVersion) =>
      pipe(
        parseUpdateVersion(newMain),
        Result.map((newVersion) => {
          if (newVersion.major > curVersion.major) {
            return 'major' as const
          }
          if (newVersion.minor > curVersion.minor) {
            return 'minor' as const
          }
          if (newVersion.patch > curVersion.patch) {
            return 'patch' as const
          }
          return 'same' as const
        }),
      ),
    ),
  )
}

const parseUpdateVersion = (
  version: string,
): Result.Result<UpdateVersion, undefined> => {
  const [major, minor, patch] = version.split('.').map((x) => Number(x))

  if (major === undefined || minor === undefined || patch === undefined) {
    return Result.fail(undefined)
  }

  return Result.succeed({ major, minor, patch })
}
